import React, { useEffect, useState } from "react";
import { classNames } from "utils/utils";
import { useRound } from "context/roundContext";
import { useLeague } from "context/leagueContext";
import { IonButton, IonContent, IonItem, IonPopover } from "@ionic/react";
import BoostsDemo from "assets/boosts";
import { useTranslation } from "react-i18next";

const Info = ({ count, label, icon, infoType }) => {
  const [internalCount, setInternalCount] = useState(count);
  const [bounceUp, setBounceUp] = useState(false);
  const [bounceDown, setBounceDown] = useState(false);

  const {
    state: { currentRound, roundEvents, userRoundData },
  } = useRound();
  const {
    state: { nextRoundId },
  } = useLeague();

  useEffect(() => {
    if (count > internalCount) {
      setBounceUp(true);
    } else if (count < internalCount) {
      setBounceDown(true);
    }
  }, [count]);

  const handleAnimationEnd = () => {
    setInternalCount(count);
    setBounceUp(false);
    setBounceDown(false);
  };

  let PopoverContent = () => null;

  if (infoType == "boosts") {
    PopoverContent = BoostsInfo;
  } else if (infoType === "roundPicks") {
    PopoverContent = RoundPicksInfo;
  } else if (infoType === "leaguePicks") {
    PopoverContent = LeaguePicksInfo;
  } else if (infoType === "deadline") {
    PopoverContent = DeadlineInfo;
  }

  return currentRound?.settled || currentRound?.id != nextRoundId ? (
    <></>
  ) : (
    <div className="flex w-fit justify-center items-center">
      <IonButton
        id={infoType}
        mode="ios"
        fill="clear"
        color="dark"
        className="m-0 h-8 customButtonNoPadding rounded-full shadow-md bg-white"
      >
        <div
          className={classNames(
            icon ? "p-1 pr-4" : "py-2 px-4",
            "flex w-fit rounded-full  text-center   text-xs justify-center items-center"
          )}
        >
          {icon && <span className="pr-1 h-fit">{icon}</span>}
          {count !== undefined && (
            <span
              className={classNames(
                bounceUp ? "animate-bounceUp" : "",
                bounceDown ? "animate-bounceDown" : "",
                "font-semibold mr-1"
              )}
              onAnimationEnd={handleAnimationEnd}
            >
              {internalCount}
            </span>
          )}
          {label && <span className="">{label}</span>}
        </div>
      </IonButton>
      <IonPopover trigger={infoType} triggerAction="click" alignment="end">
        <IonContent class="p-2">
          <PopoverContent />
        </IonContent>
      </IonPopover>
    </div>
  );
};

export default Info;

export const BoostsInfo = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col text-sm items-center justify-center p-2 text-center">
      {t("tournament.info_container.tooltip_boost")}
      <BoostsDemo />
    </div>
  );
};

export const DeadlineInfo = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col text-sm items-center justify-center p-2 text-center">
      {t("tournament.info_container.tooltip_deadline")}
    </div>
  );
};
export const RoundPicksInfo = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col text-sm items-center justify-center p-2 text-center">
      {t("tournament.info_container.tooltip_roundpick")}
    </div>
  );
};
export const LeaguePicksInfo = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col text-sm items-center justify-center p-2 text-center">
      {t("tournament.info_container.tooltip_leaguepick")}
    </div>
  );
};
